import { Box } from '@material-ui/core';
import { Task } from '../EditorPage/types';
import {
  GovernanceTestOverviewPolicy,
  PolicyHeader,
} from '@agilelab/plugin-wb-governance';
import { Policy } from '@agilelab/plugin-wb-governance-common';
import { CodeField, GenericField } from '@agilelab/plugin-wb-platform';
import { FC } from 'react';
import { format, parseISO } from 'date-fns';
import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';

interface Props {
  task: Task;
  policy: Policy;
}

export const PolicyDetailDrawerContent: FC<Props> = ({ task, policy }) => {
  return (
    <Box>
      <PolicyHeader
        name={policy.name}
        task={{
          status: task.status,
          severity: policy.severity,
          policyStatus: task.governanceEntityStatus,
        }}
      />
      <GovernanceTestOverviewPolicy
        kind="tabs"
        policy={policy}
        test={{
          errors: task.errors,
          content: task.validatedDescriptor || '',
          name: task.displayName,
        }}
        infoContent={
          <Box style={{ display: 'flex', gap: 50 }}>
            <>
              <GenericField
                label="Result Status"
                value={snakeCaseToTitleCase(task.status.toLowerCase())}
              />
              <GenericField
                label="Latest Update"
                value={format(parseISO(task.startTime), 'yyyy/MM/dd HH:mm:ss')}
              />
              {task.details && (
                <GenericField
                  label="Test Detail"
                  value={
                    <CodeField
                      title="Test Detail"
                      value={JSON.stringify(task.details, null, 4)}
                    />
                  }
                />
              )}
            </>
          </Box>
        }
      />
    </Box>
  );
};
